const constants = function() {
  window.CONST = {
    notifications: {
      status: {
        taskCreated: "TASK_CREATED",
        commentCreated: "COMMENT_CREATED",
        listDocsUpdated: "LIST_DOCS_UPDATED",
        listDocsUpdatedClients: "LIST_DOCS_62_UPDATED",
        taskCanceled: "TASK_CANCELLED",
        taskClosed: "TASK_CLOSED",
        taskStatusChanged: "TASK_STATUS_CHANGED"
      }
    }
  };
};

module.exports = constants();
